import { useEffect } from "react";

/**
 * Calls `onEscape` when the Escape key is pressed, but only while `enabled`
 * is true. Automatically cleans up the event listener on unmount.
 */
export const useEscapeKey = (enabled: boolean, onEscape: () => void): void => {
    useEffect(() => {
        if (!enabled) return;
        const handler = (e: KeyboardEvent) => {
            if (e.key === "Escape") onEscape();
        };
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, [enabled, onEscape]);
};
